import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import noop from '../../../../utils/noop';
import { getCommentableTypeForDeviationType } from '../../../../DeviationPage/redux/helpers';
import TextButton from '../../../../Buttons/TextButton';
import CommentOutlineIcon from '../../../../Icons/24x24/CommentOutline';
import { IconSize } from '../../../../Icons/IconWrap';
import Stats from '../../../../Stats';
import FaveButton from '../../../../FaveButton';
import FavingIcon from '../../../../FaveButton/FavingIcon';
import useFocusOnCommentBox from '../useFocusOnCommentBox';
import ShareControl from './ShareControl';
import { HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING } from '../../constants';
import s from './FeedCardActionBar.scss';
var FeedCardActionBar = function (_a) {
    var deviation = _a.deviation, withFaveControl = _a.withFaveControl, withCommentControl = _a.withCommentControl, className = _a.className, additionalActions = _a.additionalActions, _b = _a.openCommentThread, openCommentThread = _b === void 0 ? noop : _b, _c = _a.showMobileSharePopup, showMobileSharePopup = _c === void 0 ? noop : _c;
    var t = useTranslation().t;
    var focusOnTopCommentBox = useFocusOnCommentBox(getCommentableTypeForDeviationType(deviation.typeId), deviation.deviationId, 'topmost', true, HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING);
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['actions'] },
            withFaveControl && (React.createElement(FaveButton, { deviation: deviation, className: classnames(s['action'], s['fave-button']), "aria-label": t('deviationview.overlay.a11y.favourite') }, function (_a) {
                var isFavourite = _a.isFavourite;
                return (React.createElement(React.Fragment, null,
                    React.createElement(FavingIcon, { className: s['action-icon'], deviationId: deviation.deviationId, isFavourited: isFavourite, size: IconSize.MEDIUM, withPadding: false, disableDefaultColors: true }),
                    React.createElement("span", null, t(isFavourite
                        ? 'actionbar.inFavourites'
                        : 'actionbar.addToFavourites'))));
            })),
            withCommentControl && (React.createElement(TextButton, { className: s['action'], size: "medium", variant: "main", onClick: function () {
                    openCommentThread();
                    focusOnTopCommentBox();
                } },
                React.createElement(CommentOutlineIcon, { className: s['action-icon'], size: IconSize.MEDIUM, disableDefaultColors: true }),
                t('actionbar.comment'))),
            React.createElement(ShareControl, { className: s['action'], iconClassName: s['action-icon'], size: IconSize.MEDIUM, showMobileSharePopup: showMobileSharePopup, deviation: deviation })),
        React.createElement(Stats, { className: s['stats'], deviation: deviation, onlyNumbers: true, withFavouriteControl: withFaveControl, withCommentControl: withCommentControl, statClassName: s['stat'], withViewCount: false, withBadges: false }),
        additionalActions));
};
FeedCardActionBar.displayName = 'FeedCardActionBar';
export default FeedCardActionBar;
//# sourceMappingURL=FeedCardActionBar.js.map